/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'performance-chart-legend';
const prefix = `${moduleName}.${componentName}`;

export const showHideLegendTitle = `${prefix}.showHideLegendTitle`;

export const ENGLISH = {
    [showHideLegendTitle]: 'Show/Hide Legend',
};
